import React from 'react';
import './AuthorCard.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheckCircle,
  faEnvelope,
  faCode,
  faLaptopCode,
  faMobileAlt,
  faRocket
} from '@fortawesome/free-solid-svg-icons';

const AuthorCard = () => {
  const skills = [
    "Web Development", "React JS", "Frontend", "UI/UX Design",
    "API Integration", "Responsive Design", "JavaScript", "CSS"
  ];

  return (
    <div className="author-section">
      <div className="author-card">
        {/* Header dengan foto dan info */}
        <div className="author-header">
          <div className="author-photo-container">
            <img
              src="https://www.bagasramandani.net/images/images.jpg"
              alt="BAGAS RAMANDANI"
              className="author-photo"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "https://ui-avatars.com/api/?name=Bagas+Ramandani&background=4361ee&color=fff&size=150";
              }}
            />
            <div className="verified-badge" title="Verified Developer">
              <FontAwesomeIcon icon={faCheckCircle} size="xs" />
            </div>
          </div>

          <div className="author-info">
            <h3 className="author-name">
              BAGAS RAMANDANI
              <span className="author-title">
                <FontAwesomeIcon icon={faCode} style={{ marginRight: '5px' }} />
                Full Stack Developer
              </span>
            </h3>

            <p className="author-tagline">
              <FontAwesomeIcon icon={faLaptopCode} style={{ marginRight: '8px', color: '#4361ee' }} />
              Spesialis dalam pengembangan aplikasi web modern
            </p>
          </div>
        </div>

        {/* Kontak & Pesan */}
        <div className="author-contact">
          <div className="contact-title">
            <FontAwesomeIcon icon={faEnvelope} />
            Hubungi Saya
          </div>
          <p className="contact-message">
            "Silakan hubungi melalui media sosial di bawah ini untuk konsultasi,
            kerja sama, atau sekedar menyapa. Saya selalu senang berkolaborasi!"
          </p>
          <p className="contact-message">
            <span className="contact-highlight">
              <FontAwesomeIcon icon={faMobileAlt} style={{ marginRight: '5px' }} />
              Responsif & Ramah
            </span>
          </p>
        </div>

        {/* Skills Tags */}
        <div className="author-skills">
          {skills.map((skill, index) => (
            <span key={index} className="skill-tag">
              {skill}
            </span>
          ))}
        </div>

        {/* Stats */}
        <div className="author-stats">
          <div className="stat-item">
            <span className="stat-value">4+</span>
            <span className="stat-label">Tahun Exp</span>
          </div>
          <div className="stat-item">
            <span className="stat-value">50+</span>
            <span className="stat-label">Proyek</span>
          </div>
          <div className="stat-item">
            <span className="stat-value">100%</span>
            <span className="stat-label">Kepuasan</span>
          </div>
          <div className="stat-item">
            <FontAwesomeIcon icon={faRocket} size="lg" color="#4361ee" />
            <span className="stat-label">Siap Bekerja</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthorCard;
